import { useViewerBoxes } from 'features/knowledgeDocumentViewer/components/viewer/shared/hooks/useViewerBoxes'
import { DocumentViewerPage } from 'features/knowledgeDocumentViewer/types'

import { useImageNaturalSize } from './useImageNaturalSize'
import { usePdfAsImage } from './usePdfAsImage'

/** When set, prefer this Rolodex 6400px image URL over PDF.js rendering. */
export type ImageViewerRolodexOverride = {
  imageUrl: string | undefined
  isLoading: boolean
}

export function useImageViewerLogic(
  pdfUrl: string | undefined,
  pageNumber: number,
  scale: number,
  pageIndex: DocumentViewerPage,
  totalPages: number,
  enabled = true,
  rolodexOverride?: ImageViewerRolodexOverride
) {
  const usePdf = enabled && !rolodexOverride
  const pdfResult = usePdfAsImage(pdfUrl, pageNumber, scale, totalPages, usePdf)
  const imageUrl = rolodexOverride
    ? rolodexOverride.imageUrl
    : pdfResult.imageUrl
  const isLoading = rolodexOverride
    ? rolodexOverride.isLoading
    : pdfResult.isLoading
  const dims = useImageNaturalSize(imageUrl ?? null)
  const boxes = useViewerBoxes(dims, pageIndex, isLoading)

  return {
    imageUrl,
    dims,
    boxes,
    isLoading,
  }
}
